module.exports = __webpack_public_path__ + "2035078d8971b01ce9e18688c879492c.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/ic_tablemanagement.png
// module id = 3159
// module chunks = 0